export const FAQ_ALL_CATEGORY = 'NODE0000000003';

export const FAQ_MAIN_CATEGORY = [
  {label: '유저정보', key: 'NODE0000000004', value: 'nv1', icon: 'icoUserInfo'},
  {
    label: '방송/참여하기',
    key: 'NODE0000000011',
    value: 'nv2',
    icon: 'icoBroadCast',
  },
  {label: '선물/후원', key: 'NODE0000000452', value: 'nv3', icon: 'icoGift'},
  {label: '결제', key: 'NODE0000000212', value: 'nv4', icon: 'icoPayment'},
  {label: '아이템', key: 'NODE0000000016', value: 'nv5', icon: 'icoSubscribe'},
  {label: '기타', key: 'NODE0000000028', value: 'nv7', icon: ''},
];
